import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Button, Box, Avatar, Chip } from '@mui/material';
import { EmojiEvents, ArrowBack, Star, School, WorkspacePremium, Verified } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StudentAccolades: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Button startIcon={<ArrowBack />} onClick={() => navigate('/student-dashboard')} sx={{ mb: 3 }}>
                Back to Dashboard
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                <EmojiEvents sx={{ fontSize: 40, color: '#FFD700' }} />
                <Typography variant="h4" fontWeight="bold">Accolades & Achievements</Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>Recent Honors</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ borderRadius: 4, height: '100%', border: '1px solid rgba(0,0,0,0.05)', boxShadow: 3 }}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', p: 3 }}>
                            <Avatar sx={{ width: 80, height: 80, bgcolor: '#fff9c4', color: '#fbc02d', mb: 2 }}>
                                <Star fontSize="large" />
                            </Avatar>
                            <Typography variant="h6" fontWeight="bold">Math Wizard</Typography>
                            <Typography variant="body2" color="text.secondary">Top 5% in Algebra</Typography>
                            <Chip label="Rare" size="small" color="warning" sx={{ mt: 2 }} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ borderRadius: 4, height: '100%', border: '1px solid rgba(0,0,0,0.05)', boxShadow: 3 }}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', p: 3 }}>
                            <Avatar sx={{ width: 80, height: 80, bgcolor: '#e1f5fe', color: '#03a9f4', mb: 2 }}>
                                <School fontSize="large" />
                            </Avatar>
                            <Typography variant="h6" fontWeight="bold">Honor Roll</Typography>
                            <Typography variant="body2" color="text.secondary">Semester 1 Excellence</Typography>
                            <Chip label="Legendary" size="small" color="primary" sx={{ mt: 2 }} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ borderRadius: 4, height: '100%', border: '1px solid rgba(0,0,0,0.05)', boxShadow: 3 }}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', p: 3 }}>
                            <Avatar sx={{ width: 80, height: 80, bgcolor: '#ffebee', color: '#ff5252', mb: 2 }}>
                                <WorkspacePremium fontSize="large" />
                            </Avatar>
                            <Typography variant="h6" fontWeight="bold">Perfect Attendance</Typography>
                            <Typography variant="body2" color="text.secondary">30 Day Streak</Typography>
                            <Chip label="Common" size="small" sx={{ mt: 2 }} />
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mt: 4 }}>Certificate Collection</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Card sx={{ display: 'flex', p: 2, alignItems: 'center', gap: 3, borderRadius: 4 }}>
                        <Verified color="success" sx={{ fontSize: 40 }} />
                        <Box>
                            <Typography variant="h6" fontWeight="bold">Introduction to Physics</Typography>
                            <Typography variant="body2" color="text.secondary">Completed on Dec 20, 2025</Typography>
                        </Box>
                        <Button variant="outlined" sx={{ ml: 'auto' }}>View Certificate</Button>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default StudentAccolades;
